import L from 'leaflet';
import { Spinner, type SpinnerOptions } from 'spin.js';

import 'spin.js/spin.css';

const SpinnerMixin = {
    spin: function (state: boolean, options: SpinnerOptions): void {
        const increment = () => {
            // start spinning !
            if (!this._spinner) {
                this._spinner = new Spinner(options).spin(this._container);
                this._spinning = 0;
                this._timeout = setTimeout(() => {
                    decrement(true);
                }, 10000);
            }
            this._spinning++;
        };

        const decrement = (reset: boolean) => {
            if (reset) {
                this._spinning = 0;
            } else if (this._spinning > 0) {
                this._spinning--;
            }
            if (this._spinning <= 0) {
                if (this._timeout) {
                    clearTimeout(this._timeout);
                    this._timeout = null;
                }
                // end spinning !
                if (this._spinner) {
                    this._spinner.stop();
                    this._spinner = null;
                }
            }
        };

        if (state) {
            increment();
        } else {
            decrement(false);
        }
    },
};

const SpinMapInitHook = function () {
    this.on(
        'beforelayeradd',
        function (e) {
            if (typeof e.layer.on !== 'function') return;
            e.layer.on(
                'data:loading',
                function () {
                    this.spin(true);
                    e.layer.loading = true;
                },
                this,
            );
            e.layer.on(
                'data:loaded',
                function () {
                    this.spin(false);
                },
                this,
            );
        },
        this,
    );
    this.on(
        'layerremove',
        function (e) {
            // Clean-up
            if (e.layer.loading) this.spin(false);
            e.layer.loading = false;
            if (typeof e.layer.on !== 'function') return;
            e.layer.off('data:loaded');
            e.layer.off('data:loading');
        },
        this,
    );
};

L.Map.include(SpinnerMixin);
L.Map.addInitHook(SpinMapInitHook);

export { SpinnerMixin };
